import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import { USER_TUTORIAL_KEY } from '@/config';
import types from './mutation-types';

export function checkUserTutorial({ dispatch, state, getters }) {
  if (!isEmpty(state.checkedTutorials)) {
    return Promise.resolve(state.checkedTutorials);
  }

  const userCheckedTutorial = Cookies.get(`${USER_TUTORIAL_KEY}/${getters.currentUserId}`);

  if (isEmpty(userCheckedTutorial)) {
    return dispatch('setCheckedTutorials', {
      learningIntro: false,
    });
  }

  return dispatch('setCheckedTutorials', JSON.parse(userCheckedTutorial));
}

export function setCheckedTutorials({ commit }, checkedTutorials) {
  commit(types.SET_CHECKED_TUTORIALS, checkedTutorials);

  return Promise.resolve();
}

export function setTutorialAsChecked({ commit }, tutorial) {
  commit(types.CHECK_TUTORIAL, tutorial);

  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/app/tutorials/store/actions.js